import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import Menu from '../../form/SelectionMenu';
import BadgeCollect from '../badges/BadgeCollect';
import Resources from '../resourceLinks/ResourceLinks';
import * as appDataActions from '../../../actions/appDataActions';
import * as trackingDataActions from '../../../actions/trackingDataActions';
import * as appHelper from '../../../helpers/appHelper';
import * as kpiConstants from '../../../constants/kpiConstants';
import * as assetConstants from '../../../constants/assetConstants';
import * as appConstants from '../../../constants/appConstants';
import * as objectConstants from '../../../constants/objectConstants';
import * as localStorage from '../../../localStorage/localStorage';
import * as keyboardConstants from '../../../constants/keyboardConstants';

class IndicatorResultsPanel extends React.Component {
    constructor(props, context) {
        super(props, context);
        let outcome = appHelper.getArrayObjectByKey(props.indicatorData.outcomes, "indicator_outcome_id", props.userDataIndicator.currentOutcome.indicator_outcome_id);
        //console.log(`props.indicatorData`, props.indicatorData);
        //console.log(` props.userDataIndicator`, props.userDataIndicator);
        this.state = {
            lang: props.lang,
            indicatorMenuData: props.indicatorMenuData,
            userDataIndicator: props.userDataIndicator,
            indicatorData: props.indicatorData,
            completeIndicators: props.completeIndicators,
            allowIndicatorRedraw: true,
            locale: appHelper.getLocalData(props.indicatorData),
            outcome: outcome,
            outcomeLocale: {},
            assets: {
                screenAsset: {
                    src: "",
                    pose: "",
                    position: ""
                }
            },
            updateAssets: false,
            hasBadges: appHelper.isDefined(outcome) && appHelper.isDefined(outcome.badge_id) && outcome.badge_id > 0 && outcome.badge_id !== 0,
            badgesCollected: false,
            badge: {},
            hasResources: false,
            resourcesAreComplete: true,
            checkComplete: false,
            isComplete: false,
            checkBadge: false,
        };

        this.getAssetTarget = this.getAssetTarget.bind(this);
        this.getAssets = this.getAssets.bind(this);
        this.getAssetType = this.getAssetType.bind(this);
        this.getImagePath = this.getImagePath.bind(this);
        this.onBadgeCollected = this.onBadgeCollected.bind(this);
        this.getBadge = this.getBadge.bind(this);
        this.onResourcesComplete = this.onResourcesComplete.bind(this);
        this.onComplete = this.onComplete.bind(this);
        this.getIndicatorIsComplete = this.getIndicatorIsComplete.bind(this);
        this.getPreviousIndicator = this.getPreviousIndicator.bind(this);
        this.getNextIndicator = this.getNextIndicator.bind(this);
        this.setIndicator = this.setIndicator.bind(this);
        this.getAccessiblePreviousIndicator = this.getAccessiblePreviousIndicator.bind(this);
        this.getAccessibleNextIndicator = this.getAccessibleNextIndicator.bind(this);
        this.getAccessibleIndicator = this.getAccessibleIndicator.bind(this);
        this.getIndicatorOutcomeLocale = this.getIndicatorOutcomeLocale.bind(this);

    }

    componentDidMount() {
        this.getIndicatorOutcomeLocale();

        if (this.state.hasBadges) {
            this.getBadge(this.state.outcome.badge_id);
        }

        let getAssets = this.getAssets;

        setTimeout(function () {
            getAssets();
        }, 500);
    }


    componentWillReceiveProps(nextProps) {
        if (this.state.userDataIndicator !== nextProps.userDataIndicator) {
            let outcome = appHelper.getArrayObjectByKey(nextProps.indicatorData.outcomes, "indicator_outcome_id", nextProps.userDataIndicator.currentOutcome.indicator_outcome_id);
            this.setState({
                userDataIndicator: Object.assign({}, nextProps.userDataIndicator),
                updateAssets: true,
                hasBadges: appHelper.isDefined(nextProps.indicatorData.badge_id) && nextProps.indicatorData.badge_id > 0 && nextProps.indicatorData.badge_id !== 0 && nextProps.userDataIndicator.currentScoreRange === objectConstants.RESULT_BEST,
                checkBadge: true,
                outcome: outcome,
                outcomeLocale: appHelper.getLocalData(outcome),
            });
        }

        if (this.state.indicatorData !== nextProps.indicatorData) {
            this.setState(
                {
                    indicatorData: Object.assign({}, nextProps.indicatorData),
                    locale: Object.assign({}, appHelper.getLocalData(nextProps.indicatorData)),
                    updateAssets: true,
                    hasBadges: appHelper.isDefined(nextProps.indicatorData.badge_id) && nextProps.indicatorData.badge_id > 0 && nextProps.indicatorData.badge_id !== 0 && nextProps.userDataIndicator.currentScoreRange === objectConstants.RESULT_BEST,
                    checkBadge: true,
                }
            );
        }

        if (this.state.indicatorMenuData !== nextProps.indicatorMenuData) {
            this.setState({indicatorMenuData: Object.assign({}, nextProps.indicatorMenuData)});
        }

        if (this.state.completeIndicators !== nextProps.completeIndicators) {
            this.setState({completeIndicators: Object.assign([], nextProps.completeIndicators)});
        }

        if (this.state.lang !== nextProps.lang) {
            this.setState({
                lang: nextProps.lang,
                locale: appHelper.getLocalData(this.state.indicatorData)
            });
        }


    }

    componentDidUpdate() {

        if (this.state.updateAssets) {
            this.getAssets();
            this.getBadge(this.state.indicatorData.badge_id);
        }

        if (this.state.checkComplete) {
            this.onComplete();
        }

        if (this.state.checkBadge) {
            this.getBadge(this.state.indicatorData.badge_id);
        }
    }

    onComplete() {


        if (this.state.resourcesAreComplete && appHelper.isDefined(this.props.onComplete)) {
            this.props.onComplete(this.state.indicatorData);
            this.setState({checkComplete: false, isComplete: this.state.resourcesAreComplete});
        }
    }

    getBadge(badge_id) {
        this.setState({checkBadge: false});
        let badges = localStorage.contentData.experience.badges;

        this.setState({badge: Object.assign({}, appHelper.getArrayObjectByKey(badges, "badge_id", badge_id))});
    }

    getAssetTarget() {

        //console.log(`getAssetTarget`,this.state.userDataIndicator);
        if (this.state.userDataIndicator.currentScoreRange === objectConstants.RESULT_TYPE_BEST) {
            return kpiConstants.GREEN_ASSET;
        } else if (this.state.userDataIndicator.currentScoreRange === objectConstants.RESULT_TYPE_OK) {
            return kpiConstants.YELLOW_ASSET;
        } else if (this.state.userDataIndicator.currentScoreRange === objectConstants.RESULT_TYPE_POOR) {
            return kpiConstants.RED_ASSET;
        }
    }

    getAssets() {
        if(appHelper.isDefined(this.state.outcome)) {
            let screenAsset = this.getAssetType(this.state.outcome.asset);
            let resourceLinks = appHelper.setResourceLinks(this.state.outcome);
            let hasRequiredResources = appHelper.hasRequiredResources(resourceLinks);

            this.setState({
                updateAssets: false,
                assets: Object.assign({}, this.state.assets, {
                    screenAsset: screenAsset
                }),
                resourceLinks: Object.assign([], resourceLinks),
                hasResources: resourceLinks.length > 0,
                resourcesAreComplete: resourceLinks.length === 0 || !hasRequiredResources,
                checkComplete: true
            });
        }
    }

    getAssetType(asset) {
        let returnAsset = {};
        if (asset.constant === assetConstants.ASSET_TYPE_ID_CHARACTER) {
            let screenCharacter = appHelper.getCharacterAsset(asset);
            returnAsset = appHelper.getCharacterPose(screenCharacter, asset);
        } else if (asset.constant === assetConstants.ASSET_TYPE_ICON) {
            returnAsset = appHelper.getIconAsset(asset);
        } else if (asset.constant === assetConstants.ASSET_TYPE_IMAGE) {
            returnAsset = appHelper.getImageAsset(asset);
        }
        returnAsset = appHelper.isDefined(returnAsset.locale) ? appHelper.getLocalData(returnAsset) : returnAsset;

        if (appHelper.isDefined(asset.constant) && !appHelper.isDefined(returnAsset.type)) {
            returnAsset = Object.assign({}, returnAsset, {
                type: asset.constant
            });
        }
        return returnAsset;
    }

    getImagePath(image) {
        if (appConstants.DEVELOPMENT_MODE) {
            if (appHelper.isDefined(image) && image.length > 0) {
                return require(`../../../../moveToDist/${image}`);
            }
        } else {
            return image;
        }
    }

    onBadgeCollected() {
        this.setState({badgesCollected: true});
        //this.hide();
    }


    onResourcesComplete() {
        if (!this.state.resourcesAreComplete) {
            this.setState({resourcesAreComplete: true, checkComplete: true});
        }
    }

    getIndicatorIsComplete(indicator_id) {
        let index = appHelper.getArrayObjectIndexByKey(this.state.completeIndicators, "indicator_id", indicator_id);
        return index > -1 ? "complete" : "";
    }

    setIndicator(indicator) {
        this.state.indicatorMenuData.onMenuSelect(indicator);
    }

    getPreviousIndicator() {
        let index = appHelper.getArrayObjectIndexByKey(this.state.indicatorMenuData.menu, "constant", this.state.indicatorData.indicator_id);
        let prevIndex = this.state.indicatorMenuData.menu.length - 1;
        if (index > 0) {
            prevIndex = index - 1;
        }
        this.state.indicatorMenuData.onMenuSelect(this.state.indicatorMenuData.menu[prevIndex]);
    }

    getNextIndicator() {
        let index = appHelper.getArrayObjectIndexByKey(this.state.indicatorMenuData.menu, "constant", this.state.indicatorData.indicator_id);
        let nextIndex = 0;
        if (index < this.state.indicatorMenuData.menu.length - 1) {
            nextIndex = index + 1;
        }

        this.state.indicatorMenuData.onMenuSelect(this.state.indicatorMenuData.menu[nextIndex]);

        // this.state.indicatorMenuData.onMenuSelect(this.state.indicatorMenuData.menu[index + 1]);
    }

    getAccessiblePreviousIndicator() {
        if (event.which === keyboardConstants.ENTER_KEY || event.which === keyboardConstants.SPACEBAR_KEY) {
            event.preventDefault();
            this.getPreviousIndicator();
        }
    }

    getAccessibleNextIndicator() {
        if (event.which === keyboardConstants.ENTER_KEY || event.which === keyboardConstants.SPACEBAR_KEY) {
            event.preventDefault();
            this.getNextIndicator();
        }
    }

    getAccessibleIndicator(indicator) {
        if (event.which === keyboardConstants.ENTER_KEY || event.which === keyboardConstants.SPACEBAR_KEY) {
            event.preventDefault();
            this.setIndicator(indicator);
        }
    }

    getIndicatorOutcomeLocale() {
        if(appHelper.isDefined(this.state.outcome)) {
            let locale = appHelper.getLocalData(this.state.outcome);
            this.setState({outcomeLocale: locale});
        }
    }

    render() {
        return (
            appHelper.isDefined(this.state.outcome)
                ?
                <div className={`kpi-results-panel indicator`} ref={`indicator-results-panel`}>
                    <div className="results-row">
                        {
                            appHelper.isDefined(this.state.assets.screenAsset.src) && this.state.assets.screenAsset.src.length > 0
                                ?
                                <div className="kpi-results-column">
                                    <div className="kpi-result-asset">
                                        <img src={this.getImagePath(this.state.assets.screenAsset.src)} alt=""/>
                                    </div>
                                </div>
                                :
                                null
                        }
                        <div className="kpi-results-column flex-1">
                            {appHelper.isDefined(this.state.indicatorMenuData) && this.state.indicatorMenuData.menu.length > 1
                                ?
                                <Menu menuData={this.state.indicatorMenuData.menu}
                                      currentSelection={this.state.indicatorMenuData.currentIndicator}
                                      onMenuSelect={this.state.indicatorMenuData.onMenuSelect}
                                      idKey={this.state.indicatorMenuData.idKey}
                                      labelKey={this.state.indicatorMenuData.labelKey}/>
                                :
                                <div><strong>{this.state.outcomeLocale.title}</strong>
                                </div>
                            }
                            <div dangerouslySetInnerHTML={{__html: this.state.outcomeLocale.description}}/>
                            {
                                this.state.hasResources
                                    ?

                                    <Resources resources={this.state.resourceLinks}
                                               onResourcesComplete={this.onResourcesComplete}/>

                                    :
                                    null
                            }
                        </div>
                        <div className="kpi-results-column">
                            {appHelper.isDefined(this.state.indicatorMenuData) && this.state.indicatorMenuData.menu.length > 1
                                ?
                                <div>
                                    <div className="kpi-nav-list">
                                        <div role="button" tabIndex="0" className="back-nav"
                                             onClick={this.getPreviousIndicator}
                                             onKeyDown={this.getAccessiblePreviousIndicator}/>
                                        {this.state.indicatorMenuData.menu.map(indicator =>
                                            <div key={indicator.constant} onClick={() => this.setIndicator(indicator)}
                                                 onKeyDown={() => this.getAccessibleIndicator(indicator)}
                                                 className={`kpi-indicator ${this.getIndicatorIsComplete(indicator.constant)}`}
                                                 role="button" tabIndex="0"/>
                                        )}
                                        <div className="next-nav" role="button" tabIndex="0"
                                             onClick={this.getNextIndicator}
                                             onKeyDown={this.getAccessibleNextIndicator}/>
                                    </div>
                                </div>
                                :
                                null
                            }
                            {appHelper.isDefined(this.state.outcome) && this.state.outcome.show_score
                                ?
                                <div className="kpi-result-meter">
                                    <div className="indicator-score">
                                        <div>{this.state.userDataIndicator.current.toString()}</div>
                                    </div>
                                </div>
                                : null
                            }
                        </div>
                    </div>

                    {
                        this.state.hasBadges && appHelper.isDefined(this.state.badge.badge_id)
                            ?
                            <div className="results-row">

                                <div className="kpi-result-asset"/>
                                <div className="kpi-results-column flex-1">

                                    <BadgeCollect key={this.state.badge.badge_id}
                                                  badge_id={this.state.badge.badge_id} bite_id={this.props.bite_id}
                                                  asset_id={this.props.asset_id}
                                                  onCollected={this.onBadgeCollected}/>
                                </div>
                            </div>


                            : null
                    }

                </div>
                :
                null
        );
    }
}

IndicatorResultsPanel.propTypes = {
    userDataIndicator: PropTypes.object.isRequired,
    indicatorData: PropTypes.object.isRequired,
    asset_id: PropTypes.number,
    bite_id: PropTypes.number,
    indicatorMenuData: PropTypes.object,
    completeIndicators: PropTypes.array,
    lang: PropTypes.string.isRequired,
    onComplete: PropTypes.func,
};

IndicatorResultsPanel.contextTypes = {
    router: PropTypes.object
};

function mapStateToProps(state, ownProps) {
    let lang = state.userData.lang;
    return {
        lang: lang,

    };
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(Object.assign({}, trackingDataActions, appDataActions), dispatch)
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(IndicatorResultsPanel);



/** WEBPACK FOOTER **
 ** ./src/components/objects/indicators/IndicatorResultsPanel.js
 **/